import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  portfolioCarbon: number;
  currentImpactSlide: number;
}

const initialState: State = {
  portfolioCarbon: 0,
  currentImpactSlide: 0,
};

const slice = createSlice({
  name: 'impact',
  initialState,
  reducers: {
    setPortfolioCarbon: (state: State, action: PayloadAction<number>): State => {
      state.portfolioCarbon = action.payload;
      return state;
    },
    setCurrentImpactSlide: (state: State, action: PayloadAction<number>): State => {
      state.currentImpactSlide = action.payload;
      return state;
    },
  },
});

const { setPortfolioCarbon, setCurrentImpactSlide } = slice.actions;
export { setPortfolioCarbon, setCurrentImpactSlide };

export default slice.reducer;
